// apps/web/src/pages/pcp/conferencia-pv/use-pv-da-nota.ts — Fase 12, Plano 27 (PV-04, T-12-33).
// Carrega o rascunho de PV da NF quando a conferência abre. 403 (usuário sem pv:*) esconde tudo, sem erro visível:
// a conferência legada segue igual.
import { useEffect, useState } from 'react';
import type { RascunhoPvDaNota } from '@pieltec/contracts';

export type EstadoPvDaNota =
  | { readonly tipo: 'carregando' }
  | { readonly tipo: 'oculto' }
  | { readonly tipo: 'erro' }
  | { readonly tipo: 'ok'; readonly rascunho: RascunhoPvDaNota };

export function usePvDaNota(documentoFiscalId: string): EstadoPvDaNota {
  const [estado, setEstado] = useState<EstadoPvDaNota>({ tipo: 'carregando' });

  useEffect(() => {
    let vivo = true;
    setEstado({ tipo: 'carregando' });
    void (async () => {
      try {
        const res = await fetch(`/api/v1/vendas/pedidos/rascunho-da-nota/${encodeURIComponent(documentoFiscalId)}`, {
          credentials: 'include',
        });
        if (!vivo) return;
        if (res.status === 403) {
          setEstado({ tipo: 'oculto' });
          return;
        }
        if (!res.ok) {
          setEstado({ tipo: 'erro' });
          return;
        }
        const rascunho = (await res.json()) as RascunhoPvDaNota;
        if (vivo) setEstado({ tipo: 'ok', rascunho });
      } catch {
        if (vivo) setEstado({ tipo: 'erro' });
      }
    })();
    return () => {
      vivo = false;
    };
  }, [documentoFiscalId]);

  return estado;
}
